export const state = {
  list: [],
  tree: [],
  treeWithPositions: [],
}
